import React, { useState, useEffect, useLayoutEffect } from 'react'
import { Card } from '@mui/material'
import Modal, { ModalFooter } from '@/components/Modal'
import { styled } from '@mui/material/styles'
import { primary } from '@/constant'
import Text from '@/components/Text'
import Button from '@/components/Button'

export const ModalContent = styled(Card)(() => ({
  boxShadow: 'none',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}))

export interface CountDownConfirmProps {
  open: boolean;
  time: number;
  appName: string;
  onConfirm: () => void;
  onClose: () => void;
}

const CountDownConfirm: React.FC<CountDownConfirmProps> = (props) => {
  const { open, time, appName, onConfirm, onClose } = props
  const [seconds, setSeconds] = useState<number>(time)

  useEffect(() => {
    setSeconds(time)
  }, [time])
  useLayoutEffect(() => {
    const countDown = setInterval(() => {
      if (time > 0) {
        setSeconds((second) => {
          if (second <= 0) {
            onConfirm()
            return 0
          } else {
            return second - 1
          }
        })
      }
    }, 1000)

    return () => {
      clearInterval(countDown)
    }
  }, [time, onConfirm])

  return (
    <Modal maskClosable={false} width={500} open={open} onClose={onClose}>
      <ModalContent
        sx={{
          backgroundColor: '#fff',
          padding: '24px',
          gap: '16px',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '200px',
        }}
      >
        <Text weight="bold">提醒</Text>
        <Text
          size="xs"
          sx={{ display: 'flex', alignItems: 'center', marginLeft: '32px' }}
        >
          支付成功，
          <Text size="xs" sx={{ color: primary }}>
            {seconds}s
          </Text>
          后跳转到{appName}
        </Text>
        <ModalFooter>
          <Button type="highlight" onClick={onConfirm}>
            确定
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default CountDownConfirm
